export const STORE_APPS = {
  woolies: {
    label: "Woolworths", color: "#3E8E41",
    web: "https://www.woolworths.com.au/shop/lists",
    android: "intent://www.woolworths.com.au/shop/lists#Intent;scheme=https;package=com.woolworths;S.browser_fallback_url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.woolworths;end",
    play: "https://play.google.com/store/apps/details?id=com.woolworths",
    appstore: "https://apps.apple.com/au/app/id975089690",
    steps: [
      ["Open Lists", "In the Woolworths app tap the Lists tab at the bottom."],
      ["Add items", "Tap + New list (or open one), then Add items."],
      ["Paste", "Long-press the box and Paste — each product comes up ready to tick and add to your trolley."],
    ],
  },
  coles: {
    label: "Coles", color: "#E01A22",
    web: "https://www.coles.com.au/shopping-lists",
    android: "intent://www.coles.com.au/shopping-lists#Intent;scheme=https;package=com.coles.android.shopmate;S.browser_fallback_url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.coles.android.shopmate;end",
    play: "https://play.google.com/store/apps/details?id=com.coles.android.shopmate",
    appstore: "https://apps.apple.com/au/app/id529118855",
    steps: [
      ["Open Lists", "In the Coles app tap Lists (bottom bar)."],
      ["Add items", "Tap Create list or open one, then Add items."],
      ["Paste", "Long-press the box and Paste — Coles finds each product so you can add it to your trolley."],
    ],
  },
};

export const platform = () => (/iPhone|iPad|iPod/i.test(navigator.userAgent) ? "iphone" : /Android/i.test(navigator.userAgent) ? "android" : "desktop");

export const openStoreApp = (shop) => {
  const cfg = STORE_APPS[shop];
  const p = platform();
  const url = p === "android" ? cfg.android : cfg.web;
  const a = document.createElement("a");
  a.href = url; a.target = p === "desktop" ? "_blank" : "_self"; a.rel = "noopener noreferrer";
  document.body.appendChild(a); a.click(); a.remove();
};
